/** Shopify CDN: Minification failed

Line 106:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 107:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 117:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 122:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 124:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 129:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 136:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 144:31 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 148:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 157:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 91:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 92:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 102:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 107:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 109:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 114:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 121:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 129:31 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 133:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 142:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 76:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 77:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 87:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 94:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 99:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 106:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 114:31 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 118:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 127:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 61:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 62:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 72:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 77:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 79:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 84:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 91:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:31 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 103:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 112:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 46:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 47:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 57:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 64:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 69:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 76:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:31 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 88:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 97:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 31:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 32:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 42:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 47:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 49:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 54:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 61:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:31 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 82:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 16:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 17:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 27:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 32:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 34:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 39:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 46:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:31 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:8 Transforming const to the configured target environment ("es5") is not supported yet
Line 67:25 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 5 more hidden warnings

**/
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('click', this.onClickHandler.bind(this));

    if (this.dataset.trigger == 'infinite') {
      new IntersectionObserver(this.handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  onClickHandler() {
    if (this.classList.contains('loading') || this.classList.contains('disabled')) return;
    this.classList.add('loading');
    this.classList.add('disabled');

    const sections = InfiniteScroll.getSections();
    sections.forEach(() => {
      const url = this.dataset.url;
      InfiniteScroll.renderSectionFromFetch(url);
    });
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    this.onClickHandler();
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  static renderSectionFromFetch(url) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        InfiniteScroll.renderPagination(html);
        InfiniteScroll.renderProductGridContainer(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }

  static renderPagination(html) {
    const container = document.getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    const pagination = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').querySelector('.pagination-wrapper');
    if (pagination) {
      container.innerHTML = pagination.innerHTML;
    }
    else {
      container.remove();
    }
  }

  static renderProductGridContainer(html) {
    const container = document.getElementById('product-grid');
    const products = new DOMParser().parseFromString(html, 'text/html').getElementById('product-grid');
    container.insertAdjacentHTML('beforeend', products.innerHTML);
  }
}
customElements.define('infinite-scroll', InfiniteScroll);
